<template>
  <div class="audit-label">
    <div class="audit-label-info">
      <span class="audit-label-info-key">状态:</span>
      <span class="audit-label-info-value">审核中</span>
    </div>
    <div class="audit-label-info">
      <span class="audit-label-info-key">账号类型:</span>
      <span class="audit-label-info-value">
        <span>企业用户</span>
        <span> | </span>
        <span v-if='showBtn' class="link" @click="$LogReport.sendCustomEvent('openplat_accountmanage_typecheck_click')"><router-link :to="{name: 'companyAdd'}">{{ getText }}</router-link></span>
      </span>
    </div>
    <div class="audit-label-info">
      <span class="audit-label-info-key">单位名称:</span>
      <span class="audit-label-info-value">{{$store.state.companyInfo.co_name}}</span>
    </div>
    <div class="audit-label-info">
      <span class="audit-label-info-key">单位官方网址:</span>
      <span class="audit-label-info-value" @click="$LogReport.sendCustomEvent('openplat_accountmanage_officialweb_click')"><a class="link" :href="$store.state.companyInfo.net_addr" target="_blank">{{$store.state.companyInfo.net_addr}}</a></span>
    </div>
    <div class="audit-label-info">
      <span class="audit-label-info-key">单位所在地:</span>
      <span class="audit-label-info-value">{{$store.state.companyInfo.company_addr}}</span>
    </div>
    <div class="audit-label-info">
      <span class="audit-label-info-key">单位简介:</span>
      <span class="audit-label-info-value">{{$store.state.companyInfo.description}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "audit",
  computed: {
    showBtn () {
      const { companyInfo, arcUserInfo } = this.$store.state
      if ([1, 2].includes(companyInfo.state) && ![1, 20, 100].includes(arcUserInfo.level)) { // 如果是修改并申请 但是不是开发者
        return false
      }
      return true
    },
    getText() {
      const { state } = this.$store.state.companyInfo
      if ([1, 2].includes(state)) {
        return '修改并申请'
      } 
      return '查看'
    }
  }
}
</script>

<style scoped lang="scss">
.audit-label {
  .audit-label-info {
    padding: 16px 34px 0;
    .audit-label-info-key {
      font-size: 14px;
      color: #505050;
      display: inline-block;
      width: 180px;
    }

    .audit-label-info-value {
      font-size: 14px;
      color: #505050;

      .link {
        background: #F7FBFF;
        border-radius: 4px;
        font-size: 12px;
        color: #00A1D6;
        padding: 6px 9px;
      }
    }
  }
}
</style>
